import React from 'react';
import Banner from '~components/Elements/Banner';

const AAABanner = ({ data, className }) => {
  return <Banner type={data.type} />;
};

export default AAABanner;
